import { Collapse, GridLegacy as Grid, Stack } from "@mui/material";
import { useCurrentUser } from "hooks/useCurrentUser";

import { useStats } from "../StatsContext";
import { Summary } from "../Summary/Summary";
import { ChemicalFacilitiesDataGrid } from "./ChemicalFacilitiesDataGrid";

export function AssignmentManagementTableV2() {
  const currentUser = useCurrentUser();
  const currentUserEmail = currentUser.user?.email;
  const { statsOpen } = useStats();

  if (!currentUserEmail) return <></>;

  return (
    <Stack p={2}>
      <Grid container spacing={statsOpen ? 2 : 0}>
        <Grid item xs={12}>
          <Collapse in={statsOpen}>
            <Summary />
          </Collapse>
        </Grid>

        {/* Main content area */}
        <Grid item xs={12}>
          <ChemicalFacilitiesDataGrid />
        </Grid>
      </Grid>
    </Stack>
  );
}
